import { request } from "./transport";

export interface KolLandingPayload {
  kol: {
    slug: string;
    name: string;
    handle: string | null;
    platform: string;
    profile_url: string | null;
    follower_count: number;
  };
  ref_code: string | null;
}

export const publicKols = {
  getKolBySlug: (slug: string) =>
    request<KolLandingPayload>(`/public/kols/${encodeURIComponent(slug)}`),
};
